import React from "react";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
// @material-ui/icons components

// core components
import boxShadows from "assets/theme/box-shadow.js";

function CardTeamMember() {
  const theme = useTheme();
  return (
    <>
      <Card
        sx={{
          boxShadow: boxShadows.boxShadow + "!important",
          border: "0!important",
        }}
      >
        <CardContent>
          <Grid container component={Box} sx={{ alignItems: "center" }}>
            <Grid item xs="auto">
              <Avatar
                alt="..."
                variant="circular-xl"
                src={require("assets/img/theme/team-2.jpg").default}
              />
            </Grid>
            <Grid item sx={{ flexBasis: 0, flexGrow: 1, maxWidth: "100%" }}>
              <Typography variant="h4" component="h4" sx={{ marginBottom: 0 }}>
                John Snow
              </Typography>
              <Box
                component="p"
                sx={{
                  marginBottom: "0",
                  fontWeight: "300",
                  lineHeight: "1.7",
                  fontSize: ".875rem",
                  marginTop: "0",
                  color: theme.palette.gray[600],
                }}
              >
                Working remoteley
              </Box>
              <Box sx={{ color: theme.palette.success.main }} component="span">
                ●
              </Box>
              <Box
                sx={{ fontSize: "80%", fontWeight: "400" }}
                component="small"
              >
                Active
              </Box>
            </Grid>
            <Grid item xs="auto">
              <Button size="small" variant="contained" color="primary">
                Add
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}

export default CardTeamMember;
